import { LoadingPageSpinner } from '@hevoio/hevo-ui-toolkit';

export default function AiResponseContainerLoader({
  title
}: {
  title?: string;
}) {
  return (
    <div className='flex-col justify-center align-items-center h-100'>
      <LoadingPageSpinner
        title={title}
        subtitle={''}
      />
    </div>
  );
}
